import {
  addDays,
  addMonths,
  addWeeks,
  eachDayOfInterval,
  eachMonthOfInterval,
  eachWeekOfInterval,
} from 'date-fns'

// Strategy for Date Intervals
class DateIntervalStrategy {
  constructor(groupOn, fromDate, toDate) {
    this.groupOn = groupOn
    if (groupOn === 'DOD') {
      const endDate = addDays(new Date(toDate), 1)
      this.interval = eachDayOfInterval({start: new Date(fromDate), end: endDate})
    } else if (groupOn === 'WOW') {
      const endDate = addWeeks(new Date(toDate), 1)
      this.interval = eachWeekOfInterval({start: new Date(fromDate), end: endDate})
    } else if (groupOn === 'MOM') {
      const endDate = addMonths(new Date(toDate), 1)
      this.interval = eachMonthOfInterval({start: new Date(fromDate), end: endDate})
    } else {
      throw new Error('Unsupported groupOn value')
    }
  }

  static getInterval(groupOn, fromDate, toDate) {
    if (groupOn === 'DOD') {
      const endDate = addDays(new Date(toDate), 1)
      return eachDayOfInterval({start: new Date(fromDate), end: endDate})
    }
    if (groupOn === 'WOW') {
      const endDate = addWeeks(new Date(toDate), 1)
      return eachWeekOfInterval({start: new Date(fromDate), end: endDate})
    }
    if (groupOn === 'MOM') {
      const endDate = addMonths(new Date(toDate), 1)
      return eachMonthOfInterval({start: new Date(fromDate), end: endDate})
    }
    throw new Error('Unsupported groupOn value')
  }
}

export default DateIntervalStrategy
